import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { InputPasswordReactMode } from 'app/shared/components/reactive-inputs/input-password-react/input-password-react.enum';
import { NotificationService } from 'app/shared/services/notification.service';

@Component({
  selector: 'app-input-react-prompt-modal',
  templateUrl: './input-react-prompt-modal.component.html',
  styleUrls: ['./input-react-prompt-modal.component.scss']
})
export class InputPromptModalComponent implements OnInit {

  @ViewChild('content') contentModal;
  @Input() label: string;
  @Output() getValue = new EventEmitter();

  public form: FormGroup;
  public iprm = InputPasswordReactMode;
  constructor(
    private modalService: NgbModal,
    protected notification: NotificationService
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      valor: new FormControl(''),
    })
  }

  OKMethod(closeMethod): void {
    this.getValue.emit(this.form.get('valor').value);
    this.form.get('valor').setValue('');
    closeMethod('Close click');
  }

  showModal() {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };

    this.modalService.open(this.contentModal, ngbModalOptions).result.then((result) => {

    }, (reason) => {
    });
  }

}
